<template>
    <circle cx="10" cy="10.5" r="9" :stroke="color" stroke-width="2"/>
    <path d="M10 6.23474V14.7651" :stroke="color" stroke-width="2"/>
    <path d="M14.2656 10.4999L5.73524 10.4999" :stroke="color" stroke-width="2"/>
</template>

<script>
    export default {
        name: 'icon-plus',
        props: {
            color: {
                type: String,
                default: '#00AF41'
            }
        }
    }
</script>